import { styled } from '@linaria/react';
import PopTopicTag from '@fe-news/components/atoms/PopTopic/PopTopicTag';
import { PopTopicCategory } from '@fe-news/constants/pop-topic/type';

const TagsGroup = styled.div`
  display: flex;
  column-gap: 8px;
  position: absolute;

  z-index: 1;
  top: -12px;
  left: 16px;
`;

type PopTopicGroupTagsProps = {
  hotIssueTag: PopTopicCategory[];
};

const PopTopicGroupTags: React.FC<PopTopicGroupTagsProps> = ({ hotIssueTag }) => {
  if (hotIssueTag.length === 0) return null;

  return (
    <TagsGroup>
      {hotIssueTag.map(tag => (
        <PopTopicTag key={tag.categoryId} tag={tag} />
      ))}
    </TagsGroup>
  );
};

export default PopTopicGroupTags;
